import React from 'react';
import PropTypes from 'prop-types';


const KBAAnswerShape = PropTypes.shape({
  answer: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
});

const KBAQuestionShape = PropTypes.shape({
  answers: PropTypes.arrayOf(KBAAnswerShape).isRequired,
  id: PropTypes.number.isRequired,
  question: PropTypes.string.isRequired,
});

export const KBAShape = PropTypes.shape({
  answers: PropTypes.shape({
    questions: PropTypes.arrayOf(KBAQuestionShape).isRequired,
  }).isRequired,
});


const KBAMultiStepFormPropTypes = {
  prompts: KBAShape.isRequired,
  answers: PropTypes.object.isRequired,
  handleKBAOptionClickClosure: PropTypes.func.isRequired,
};

const KBAMultiStepForm = ({ prompts, answers, handleKBAOptionClickClosure }) => (
  <>
    <div className="header-40">
      <div className="col">
        <h2>KBA Questions</h2>
      </div>
    </div>

    <div className="header-24">
      <div className="col">
        <p>To continue, complete the verification (KBA) questions below.</p>
      </div>
    </div>

    <div className="kba-questions-container">
      {prompts.answers.questions.map(question => (
        <div className="kba-question" key={question.id}>
          <div className="kba-question-prompt">
            {` ${question.question} `}
          </div>

          {question.answers.map(answer => (
            <div key={answer.id}>
              <label>
                <input
                  type="radio"
                  onChange={handleKBAOptionClickClosure(question.id, answer.id)}
                  checked={+answers[question.id] === +answer.id}
                />
                {answer.answer}
              </label>
            </div>
          ))}
        </div>
      ))}
    </div>
  </>
);

KBAMultiStepForm.propTypes = KBAMultiStepFormPropTypes;

export default KBAMultiStepForm;
